// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*** Side naviation example
  https://www.w3schools.com/howto/howto_js_sidenav.asp
*/

#navbar-mount {
  position: fixed;
  top: 3px;
  z-index: 2;
  width: 100%;
  transition: top 0.3s; /* Transition effect when sliding down (and up) */
}

/* Navbar Conatainer */
.navbar-ct {
  display: flex;
  justify-content: space-between;
  padding: 4px 20px 0 10px;
  align-items: center;
  margin: 2px 3px 8px 3px;
  background-color: var(--brand-dark1);
  border-radius: 10px;
  /* background-color: transparent; */
}



/* Brand Name (navbar-left-ct) */
.brand-name-in-nav-ct {
  color: var(--brand-white1);
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.brand-name-in-nav-ct:hover {
  cursor: pointer;
}

.brand-name-in-nav {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  font-family: var(--font-family1);
  margin-left: 5px;
}

.slogan-in-nav {
  margin: 0;
  font-size: 1.25rem;
  font-family: var(--font-family-mono);
  color: var(--brand-white2);
}

.logo-brackets {
  color: var(--brand-blue1);
  font-family: var(--font-braces1);
}

.logo-spread {
  color: var(--brand-red1);
  font-family: var(--font-dots1);
}



/* Navbar Right Container */
.navbar-right-ct {
  display: flex;
  gap: 60px;
  align-items: center;
}



/* js applied styles to handle fade onscroll */
.navbar-fade-in {
  background-color: var(--brand-dark1);
  -webkit-transition: background-color 700ms linear;
  -ms-transition: background-color 700ms linear;
  transition: background-color 700ms linear;
}

.navbar-fade-out {
  animation-name: none;
  background-color: transparent;
  box-shadow: none;
  -webkit-transition: background-color 700ms linear;
  -ms-transition: background-color 700ms linear;
  transition: background-color 700ms linear;
}




/* Side Bar Waffle Menue */
#sidebar-waffle-btn-ct {
  display: flex;
  flex-wrap: wrap;
  height: 25px;
  width: 30px;
  cursor: pointer;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
}

#sidebar-waffle-btn-ct span {
  display: block;
  height: 4px;
  width: 100%;
  background-color: var(--brand-white2);
  border-radius: 10px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

#sidebar-waffle-btn-ct.open span {
  background-color: var(--brand-red1);
}

#sidebar-waffle-btn-ct.open span:nth-child(1) {
  display: none;
}

#sidebar-waffle-btn-ct.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg) translateX(5px) translateY(5px);
}

#sidebar-waffle-btn-ct.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg) translateX(3px) translateY(-4px);
}





/* mobile logo */
.logo-home-icon-ct {
  display: none;
  transform: translateY(-2px);
}

.logo-home-icon-ct img {
  border: 3px solid var(--brand-red1);
  border-radius: 50%;
}

.logo-home-icon-ct img:hover {
  border-color: var(--brand-green1);
}





/* Phone Number */
.phone-number-ct {
  text-align: center;
  font-size: 1.5rem;
  font-family: var(--font-family1);
  letter-spacing: .5px;
}
.phone-number-ct a {
  text-decoration: none;
  color: var(--brand-white3);
}

.phone-number-ct a:hover {
  color: var(--brand-white2);
}





/* Side Nav Menu */
#side-nav-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  height: 100%;
  width: 0;
  position: fixed;
  z-index: 10;
  top: 75px;
  right: -3px;
  background-color: var(--brand-dark3);
  border-radius: 20px 0 0 20px;
  overflow-x: hidden;
  transition: 0.4s;
}

#side-nav-menu.side-nav-menu-active {
  width: 100vh;
  border: 3px dotted var(--brand-red1);
  padding: 30px 0;
}

#side-nav-menu a {
  padding: 8px 0 0 0;
  text-decoration: none;
  font-size: 25px;
  color: var(--brand-white2);
  transition: 0.3s;
  font-family: var(--font-family1);

  /* hidden border */
  border-bottom: 3px transparent dotted;
}

#side-nav-menu a:hover {
  color: var(--brand-green1);
  border-bottom: 3px var(--brand-red1) dotted;
}




/* media queries
  • Desktop
*/
/* @media (max-width: 709px) {

} */



/* media queries
  • Mobile
*/
@media (max-width: 710px) {

  .brand-name-in-nav-ct {
    display: none;
  }

  /* handle rendering logo image */
  .logo-home-icon-ct {
    display: flex;
    height: 50px;
    width: 50px;
  }

  .navbar-ct {
    height: 50px;
  }


  #side-nav-menu {
    top: 60px;
  }

  #side-nav-menu.side-nav-menu-active {
    width: 100vw;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/navbars/Navabar1/Navbar1.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,WAAW;EACX,oBAAoB,EAAE,iDAAiD;AACzE;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,mCAAmC;AACrC;;;;AAIA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;;;AAIA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;;;AAIA,8CAA8C;AAC9C;EACE,oCAAoC;EACpC,iDAAiD;EACjD,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,iDAAiD;EACjD,6CAA6C;EAC7C,yCAAyC;AAC3C;;;;;AAKA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,0DAA0D;AAC5D;;;;;;AAMA,gBAAgB;AAChB;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;;;;;AAMA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;;;;;AAMA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;;EAER,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,WAAW;EACX,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;;EAEhC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;;;;AAKA;;CAEC;AACD;;GAEG;;;;AAIH;;CAEC;AACD;;EAEE;IACE,aAAa;EACf;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;AAEF","sourcesContent":["/*** Side naviation example\n  https://www.w3schools.com/howto/howto_js_sidenav.asp\n*/\n\n#navbar-mount {\n  position: fixed;\n  top: 3px;\n  z-index: 2;\n  width: 100%;\n  transition: top 0.3s; /* Transition effect when sliding down (and up) */\n}\n\n/* Navbar Conatainer */\n.navbar-ct {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 20px 0 10px;\n  align-items: center;\n  margin: 2px 3px 8px 3px;\n  background-color: var(--brand-dark1);\n  border-radius: 10px;\n  /* background-color: transparent; */\n}\n\n\n\n/* Brand Name (navbar-left-ct) */\n.brand-name-in-nav-ct {\n  color: var(--brand-white1);\n  text-decoration: none;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.brand-name-in-nav-ct:hover {\n  cursor: pointer;\n}\n\n.brand-name-in-nav {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 700;\n  font-family: var(--font-family1);\n  margin-left: 5px;\n}\n\n.slogan-in-nav {\n  margin: 0;\n  font-size: 1.25rem;\n  font-family: var(--font-family-mono);\n  color: var(--brand-white2);\n}\n\n.logo-brackets {\n  color: var(--brand-blue1);\n  font-family: var(--font-braces1);\n}\n\n.logo-spread {\n  color: var(--brand-red1);\n  font-family: var(--font-dots1);\n}\n\n\n\n/* Navbar Right Container */\n.navbar-right-ct {\n  display: flex;\n  gap: 60px;\n  align-items: center;\n}\n\n\n\n/* js applied styles to handle fade onscroll */\n.navbar-fade-in {\n  background-color: var(--brand-dark1);\n  -webkit-transition: background-color 700ms linear;\n  -ms-transition: background-color 700ms linear;\n  transition: background-color 700ms linear;\n}\n\n.navbar-fade-out {\n  animation-name: none;\n  background-color: transparent;\n  box-shadow: none;\n  -webkit-transition: background-color 700ms linear;\n  -ms-transition: background-color 700ms linear;\n  transition: background-color 700ms linear;\n}\n\n\n\n\n/* Side Bar Waffle Menue */\n#sidebar-waffle-btn-ct {\n  display: flex;\n  flex-wrap: wrap;\n  height: 25px;\n  width: 30px;\n  cursor: pointer;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease-in-out;\n  -moz-transition: .5s ease-in-out;\n  -o-transition: .5s ease-in-out;\n  transition: .5s ease-in-out;\n}\n\n#sidebar-waffle-btn-ct span {\n  display: block;\n  height: 4px;\n  width: 100%;\n  background-color: var(--brand-white2);\n  border-radius: 10px;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .25s ease-in-out;\n  -moz-transition: .25s ease-in-out;\n  -o-transition: .25s ease-in-out;\n  transition: .25s ease-in-out;\n}\n\n#sidebar-waffle-btn-ct.open span {\n  background-color: var(--brand-red1);\n}\n\n#sidebar-waffle-btn-ct.open span:nth-child(1) {\n  display: none;\n}\n\n#sidebar-waffle-btn-ct.open span:nth-child(2) {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg) translateX(5px) translateY(5px);\n}\n\n#sidebar-waffle-btn-ct.open span:nth-child(3) {\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  transform: rotate(-45deg) translateX(3px) translateY(-4px);\n}\n\n\n\n\n\n/* mobile logo */\n.logo-home-icon-ct {\n  display: none;\n  transform: translateY(-2px);\n}\n\n.logo-home-icon-ct img {\n  border: 3px solid var(--brand-red1);\n  border-radius: 50%;\n}\n\n.logo-home-icon-ct img:hover {\n  border-color: var(--brand-green1);\n}\n\n\n\n\n\n/* Phone Number */\n.phone-number-ct {\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: var(--font-family1);\n  letter-spacing: .5px;\n}\n.phone-number-ct a {\n  text-decoration: none;\n  color: var(--brand-white3);\n}\n\n.phone-number-ct a:hover {\n  color: var(--brand-white2);\n}\n\n\n\n\n\n/* Side Nav Menu */\n#side-nav-menu {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n\n  height: 100%;\n  width: 0;\n  position: fixed;\n  z-index: 10;\n  top: 75px;\n  right: -3px;\n  background-color: var(--brand-dark3);\n  border-radius: 20px 0 0 20px;\n  overflow-x: hidden;\n  transition: 0.4s;\n}\n\n#side-nav-menu.side-nav-menu-active {\n  width: 100vh;\n  border: 3px dotted var(--brand-red1);\n  padding: 30px 0;\n}\n\n#side-nav-menu a {\n  padding: 8px 0 0 0;\n  text-decoration: none;\n  font-size: 25px;\n  color: var(--brand-white2);\n  transition: 0.3s;\n  font-family: var(--font-family1);\n\n  /* hidden border */\n  border-bottom: 3px transparent dotted;\n}\n\n#side-nav-menu a:hover {\n  color: var(--brand-green1);\n  border-bottom: 3px var(--brand-red1) dotted;\n}\n\n\n\n\n/* media queries\n  • Desktop\n*/\n/* @media (max-width: 709px) {\n\n} */\n\n\n\n/* media queries\n  • Mobile\n*/\n@media (max-width: 710px) {\n\n  .brand-name-in-nav-ct {\n    display: none;\n  }\n\n  /* handle rendering logo image */\n  .logo-home-icon-ct {\n    display: flex;\n    height: 50px;\n    width: 50px;\n  }\n\n  .navbar-ct {\n    height: 50px;\n  }\n\n\n  #side-nav-menu {\n    top: 60px;\n  }\n\n  #side-nav-menu.side-nav-menu-active {\n    width: 100vw;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
